// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy_internal_banner.position-relative {
    background: #F9F9FE;
}
.privacy_internal_banner .container {
    overflow: hidden;
    position: relative;
    padding: 100px 250px  100px 0px;
    z-index: 2;
}
.privacy_internal_banner img {
    width: 100%;
    height: 116%;
    position: absolute;
    object-fit: contain;
    z-index: -1;
    top: 0px;
}
.privacy_internal_banner .apply-button {
    margin: 20px 0px 0px 0px;
}
.careerI_banner_icons {
    display: flex;
    justify-content: flex-start;
}
.careerI_banner_icons .icon{
    margin-right: 40px;
}
.careerI_banner_icons svg {
    margin-right: 5px;
}
.similar-job-card {
    border: 2px solid var(--dBlue);
    padding: 20px;
    border-radius: 25px;
}
.job-icons {
    display: flex;
    justify-content: space-between;
}
.job-info p:first-child{
    font-size: var(--pSize);
    font-weight: 700;
}
.job-info p:nth-child(2){
    font-size: var(--f20);
    font-weight: 700;
    color: var(--dBlue);
}
.job-info p:last-child{
    font-size: var(--pSize);
    font-weight: 400;
}
a.apply-button {
    background: var(--dBlue);
    color: #fff;
    padding: 10px 30px;
    border-radius: 25px;
    display: block;
    margin: 20px auto auto;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    text-align: center;
}
.similar-job-card .icon svg
{
margin-right: 5px;

}
.similar-job-card .icon:last-child svg
{
color: var(--dBlue);
}
`, "",{"version":3,"sources":["webpack://./src/pages/CareerInternal.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,QAAQ;AACZ;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,0BAAkB;IAAlB,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;;AAEA,iBAAiB;;AAEjB;AACA;;AAEA,mBAAmB;AACnB","sourcesContent":[".privacy_internal_banner.position-relative {\n    background: #F9F9FE;\n}\n.privacy_internal_banner .container {\n    overflow: hidden;\n    position: relative;\n    padding: 100px 250px  100px 0px;\n    z-index: 2;\n}\n.privacy_internal_banner img {\n    width: 100%;\n    height: 116%;\n    position: absolute;\n    object-fit: contain;\n    z-index: -1;\n    top: 0px;\n}\n.privacy_internal_banner .apply-button {\n    margin: 20px 0px 0px 0px;\n}\n.careerI_banner_icons {\n    display: flex;\n    justify-content: flex-start;\n}\n.careerI_banner_icons .icon{\n    margin-right: 40px;\n}\n.careerI_banner_icons svg {\n    margin-right: 5px;\n}\n.similar-job-card {\n    border: 2px solid var(--dBlue);\n    padding: 20px;\n    border-radius: 25px;\n}\n.job-icons {\n    display: flex;\n    justify-content: space-between;\n}\n.job-info p:first-child{\n    font-size: var(--pSize);\n    font-weight: 700;\n}\n.job-info p:nth-child(2){\n    font-size: var(--f20);\n    font-weight: 700;\n    color: var(--dBlue);\n}\n.job-info p:last-child{\n    font-size: var(--pSize);\n    font-weight: 400;\n}\na.apply-button {\n    background: var(--dBlue);\n    color: #fff;\n    padding: 10px 30px;\n    border-radius: 25px;\n    display: block;\n    margin: 20px auto auto;\n    width: fit-content;\n    text-align: center;\n}\n.similar-job-card .icon svg\n{\nmargin-right: 5px;\n\n}\n.similar-job-card .icon:last-child svg\n{\ncolor: var(--dBlue);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
